// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"TabView_tabContainer__tt5HU","tabContainerAlt":"TabView_tabContainerAlt__RTf6s"};